import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b1e0804&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=5b1e0804&scoped=true&lang=less&"
import style1 from "./style.less?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1e0804",
  null
  
)

export default component.exports